import type { UserListItem } from "@/types/plan.types";

/**
 * Counts unique workspaces from admin users payload.
 * Uses tenant_id as workspace identity, with a per-user fallback when missing.
 */
export const getTotalWorkspaces = (users: UserListItem[]): number => {
  const workspaceIds = new Set<string>();

  users.forEach((user) => {
    const tenantId = user.tenant_id?.trim();
    workspaceIds.add(tenantId && tenantId.length > 0 ? tenantId : `user:${user.id}`);
  });

  return workspaceIds.size;
};
